import LegalLayout from "@/components/LegalLayout";
import Seo from "@/components/Seo";

export const Datenschutz = () => {
  return (
    <LegalLayout title="Datenschutzerklärung" updated="01.08.2026">
      <Seo
        title="Datenschutzerklärung – Kurpfalz Automation"
        description="Datenschutzerklärung von Kurpfalz Automation (ck-partners) gemäß DSGVO."
        path="/datenschutz"
      />
      <section>
        <h2 className="font-semibold text-lg text-[#16273F]">1. Verantwortlicher</h2>
        <p className="mt-2">
          Verantwortlicher im Sinne der DSGVO ist:<br />
          Christian Knapp · ck-partners (Kurpfalz Automation)<br />
          Oberdorfstr. 25, 68542 Heddesheim<br />
          E-Mail: <a className="underline hover:text-[#16273F]" href="mailto:ck-partners@gmx.net">ck-partners@gmx.net</a>
        </p>
      </section>

      <section>
        <h2 className="font-semibold text-lg text-[#16273F]">2. Hosting &amp; Server-Logfiles</h2>
        <p className="mt-2">
          Diese Website wird gehostet bei: <strong>[Hosting-Anbieter noch
          festzulegen]</strong>. Beim Aufruf der Website erhebt der
          Hosting-Anbieter automatisch Informationen in Server-Logfiles, die
          Ihr Browser übermittelt (IP-Adresse, Datum/Uhrzeit, aufgerufene
          Seite, Referrer-URL, Browsertyp). Rechtsgrundlage ist Art. 6 Abs. 1
          lit. f DSGVO (berechtigtes Interesse an technisch fehlerfreiem
          Betrieb und Sicherheit). Speicherdauer: max. 90 Tage.
        </p>
      </section>

      <section>
        <h2 className="font-semibold text-lg text-[#16273F]">3. Kontaktformular</h2>
        <p className="mt-2">
          Wenn Sie unser Kontaktformular nutzen, werden die von Ihnen
          eingegebenen Daten (Name, E-Mail-Adresse, Telefonnummer, Betrieb,
          Nachricht) direkt aus Ihrem Browser an unsere
          Workflow-Automatisierungsplattform <strong>n8n Cloud</strong>{" "}
          übermittelt, um Ihre Anfrage zu bearbeiten und zu beantworten.
          Rechtsgrundlage ist Art. 6 Abs. 1 lit. b DSGVO (vorvertragliche
          Anfrage) bzw. lit. f DSGVO (berechtigtes Interesse an
          Kontaktaufnahme). Speicherdauer: bis zur Erledigung Ihrer Anfrage
          bzw. bis zum Ende des Geschäftsjahres zzgl. gesetzlicher
          Aufbewahrungsfristen, sofern ein Vertrag zustande kommt.
        </p>
      </section>

      <section>
        <h2 className="font-semibold text-lg text-[#16273F]">
          4. Einsatz von KI-Systemen &amp; weiteren Auftragsverarbeitern
        </h2>
        <p className="mt-2">
          Zur Automatisierung unserer internen Abläufe (z. B. Auswertung und
          Kategorisierung von Anfragen, Angebotserstellung) setzen wir
          folgende Auftragsverarbeiter und technische Dienste ein:
        </p>
        <ul className="mt-3 list-disc pl-5 space-y-1.5">
          <li><strong>n8n Cloud</strong> – Workflow-Automatisierung (Empfang &amp; Verarbeitung Ihrer Formulardaten)</li>
          <li><strong>Anthropic PBC</strong> (USA) – KI-Modell „Claude" zur automatisierten Auswertung von Anfragen</li>
          <li><strong>OpenAI, L.L.C.</strong> (USA) – GPT-4o, ausschließlich zur Dokumenterkennung (OCR) im Kundenportal, nicht auf dieser Website</li>
          <li><strong>Google Ireland Ltd.</strong> – Google Sheets, zur internen Ablage von Lead-Daten</li>
          <li><strong>Apify Technologies s.r.o.</strong> (CZ) – Recherche geschäftlicher Kontaktdaten für unsere Vertriebsarbeit</li>
          <li><strong>Emergent</strong> – Hosting des White-Label-Kundenportals</li>
          <li><strong>GMX GmbH</strong> – Versand von E-Mails</li>
        </ul>
        <p className="mt-3">
          Für Übermittlungen an Anbieter mit Sitz in den USA (Anthropic,
          OpenAI) stützen wir uns auf Standardvertragsklauseln (SCCs) bzw.
          vergleichbare Garantien der jeweiligen Anbieter. Mit allen
          Auftragsverarbeitern bestehen oder werden Verträge nach Art. 28
          DSGVO (AVV) abgeschlossen.
        </p>
      </section>

      <section>
        <h2 className="font-semibold text-lg text-[#16273F]">
          5. Hinweis für Nutzer:innen unseres White-Label-Kundenportals
        </h2>
        <p className="mt-2">
          Daten von Endkund:innen (z. B. Rechnungen, Kontaktdaten, Termine),
          die im White-Label-Kundenportal unserer Kundschaft verarbeitet
          werden, verarbeiten wir im Auftrag unserer jeweiligen Kundschaft
          gemäß Art. 28 DSGVO als Auftragsverarbeiter. Verantwortlich für
          diese Daten ist die jeweilige Kundschaft, die das Portal einsetzt.
          Betroffene Endkund:innen wenden sich für Auskunfts-,
          Berichtigungs- oder Löschanfragen primär an diese Kundschaft; ein
          direktes Auskunftsersuchen an uns ist ebenfalls möglich (Kontakt
          siehe oben).
        </p>
      </section>

      <section>
        <h2 className="font-semibold text-lg text-[#16273F]">6. Cookies &amp; Reichweitenmessung</h2>
        <p className="mt-2">
          Diese Website setzt <strong>keine Drittanbieter-Tracking-Tools</strong>{" "}
          ein (z. B. kein Google Analytics, kein Meta Pixel). Beim ersten
          Besuch zeigen wir Ihnen ein Cookie-Banner, über das Sie in einem
          zweistufigen Verfahren entscheiden können, ob Sie unserer eigenen,
          erstanbieterseitigen Reichweitenmessung zustimmen: Sie öffnen bei
          Bedarf zunächst die Einstellungen, wählen dort gezielt das
          Analyse-Cookie aus und bestätigen Ihre Auswahl in einem zweiten
          Schritt separat („Auswahl speichern"). Ohne diese ausdrückliche
          Zustimmung wird kein Analyse-Cookie gesetzt und keine Nutzung
          erfasst. Sie können jederzeit ebenso leicht ablehnen wie zustimmen.
        </p>
        <p className="mt-3">Bei Zustimmung erheben wir über unsere eigene Automatisierungsplattform (n8n Cloud):</p>
        <ul className="mt-3 list-disc pl-5 space-y-1.5">
          <li>aufgerufene Seiten und die grobe Herkunft des Zugriffs (Referrer, ggf. UTM-Parameter aus Kampagnenlinks)</li>
          <li>ob und wie weit auf einer Seite gescrollt wurde sowie die ungefähre Verweildauer</li>
          <li>ob unser Kontaktformular begonnen bzw. abgeschickt wurde (ohne die eingegebenen Inhalte)</li>
        </ul>
        <p className="mt-3">Wir setzen dabei folgende Cookies:</p>
        <ul className="mt-3 list-disc pl-5 space-y-1.5">
          <li><code>ka_consent</code> – speichert Ihre Consent-Entscheidung, Laufzeit 180 Tage</li>
          <li><code>ka_sid</code> – zufällige, nicht personenbezogene Kennung zur Wiedererkennung Ihres Browsers über mehrere Besuche hinweg, wird nur bei Zustimmung gesetzt, Laufzeit 180 Tage</li>
        </ul>
        <p className="mt-3">
          Rechtsgrundlage für das Analyse-Cookie ist Ihre Einwilligung (Art. 6
          Abs. 1 lit. a DSGVO i. V. m. § 25 Abs. 1 TTDSG). Sie können Ihre
          Einwilligung jederzeit mit Wirkung für die Zukunft widerrufen,
          indem Sie die Cookies Ihres Browsers für diese Website löschen –
          beim nächsten Besuch erscheint das Cookie-Banner dann erneut.
        </p>
      </section>

      <section>
        <h2 className="font-semibold text-lg text-[#16273F]">7. Ihre Rechte</h2>
        <p className="mt-2">
          Ihnen stehen nach der DSGVO folgende Rechte zu: Auskunft (Art. 15),
          Berichtigung (Art. 16), Löschung (Art. 17), Einschränkung der
          Verarbeitung (Art. 18), Datenportabilität (Art. 20) und
          Widerspruch (Art. 21). Wenden Sie sich hierzu an{" "}
          <a className="underline hover:text-[#16273F]" href="mailto:ck-partners@gmx.net">ck-partners@gmx.net</a>.
          Zudem steht Ihnen ein Beschwerderecht bei der zuständigen
          Aufsichtsbehörde zu: Landesbeauftragte für Datenschutz und
          Informationsfreiheit Baden-Württemberg.
        </p>
      </section>

      <section>
        <h2 className="font-semibold text-lg text-[#16273F]">8. Datensicherheit</h2>
        <p className="mt-2">
          Wir setzen technische und organisatorische Maßnahmen ein, um Ihre
          Daten zu schützen, u. a. TLS/SSL-Verschlüsselung der Übertragung,
          Zugriffskontrollen auf unsere Systeme sowie eine strikte Trennung
          zwischen den Automatisierungs-Workflows und dieser Website (die
          Website selbst hat keinen schreibenden Zugriff auf unsere internen
          n8n-Workflows oder KI-Agenten – sie sendet Formulardaten
          ausschließlich einmalig an einen dediziert dafür vorgesehenen
          Webhook).
        </p>
      </section>
    </LegalLayout>
  );
};

export default Datenschutz;
